import React, { Fragment, useEffect, useState } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import Hero from '../../components/hero/Hero';
import MarqueeSection from '../../components/MarqueeSection/MarqueeSection';
import TeamSection from '../../components/TeamSection/TeamSection';
import Testimonial from '../../components/Testimonial/Testimonial';
import BlogSection from '../../components/BlogSection/BlogSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Contactpage from "../../components/Contactpage/Contactpage";
import TerminModal from "../../components/TerminModal/TerminModal";
import NoticeModal from "../../components/NoticeModal/NoticeModal";

const HomePage = () => {

    const [terminModalOpen, setTerminModalOpen] = useState(false);

    const openTerminModal = () => {
        setTerminModalOpen(true);
    }

    const closeTerminModal = () => {
        setTerminModalOpen(false);
    }

    useEffect(() => {
        const target = sessionStorage.getItem('scrollTarget');
        if (!target) {
            return;
        }

        sessionStorage.removeItem('scrollTarget');

        const scrollAfterRender = () => {
            document.getElementById(target)?.scrollIntoView({ behavior: 'smooth' });
        };

        const timer = setTimeout(scrollAfterRender, 100);
        return () => clearTimeout(timer);
    }, []);

    return (
        <Fragment>
            <Navbar openTerminModal={openTerminModal}/>
            <Hero openTerminModal={openTerminModal} />
            <MarqueeSection />
            <Contactpage section="prescriptionOnly" openTerminModal={openTerminModal}/>
            <BlogSection />
            {/*<ServiceSection />*/}
            {/*<WhyChoose />*/}
            {/*<TeamSection />*/}
            <Testimonial />
            <TeamSection />
            <Contactpage section="contactOnly"/>
            {/*<About />*/}
            <Footer />
            <Scrollbar openTerminModal={openTerminModal} />
            <NoticeModal />
            <TerminModal open={terminModalOpen} onCloseModal={closeTerminModal} />
        </Fragment>
    )
};

export default HomePage;